export const text = {
  heading: 'Membership Plan',
  addMembershipPlan: 'Add Membership Plan',
  editMembershipPlan: 'Edit Membership Plan',
  enterPlanName: 'Enter plan name',
  enterDisplayOrder: 'Enter display order',
  planName: 'Plan Name',
  discountOrder: 'Discount Order',
  monthlyOption: 'Monthly Option',
  yearlyOptions: 'Yearly Options',
  monthlyCost: 'Monthly Cost',
  enterMonthlyCost: 'Enter Monthly Cost',
  yearlyCost: 'Yearly Cost',
  enterYearlyCost: 'Enter Yearly Cost',
  typesOfBenefit: 'Type Of Benefit',
  selectType: 'Select type of benefit',
  selectSubCategoryService: 'Select the Sub Category Service',
  selectSubCategoryPlaceholder: 'Select the sub category service',
  typeOfSubCategorySaving: 'Type of Sub Category Saving',
  savingAmount: 'Saving Amount',
  description: 'Description',
  enterSavingAmount: 'Enter saving amount',
  selectDiscount: 'Select the Discount From Quote System',
  selectDiscountPlaceholder: 'Select the discount from quote system',
  quoteSaving: 'Quote Saving',
  lineItemSaving: 'Line Item Saving',
  yearlyOneTime: 'Yearly One Time Cost',
  additionalDiscount: 'Additional Discount',
  lengthOfMembership: 'Length of Membership',
  displayOrder: 'Display Order',
  discountPlaceholder: 'addition discount',
  lengthOfMembershipPlaceholder: 'length of membership',
  displayOrderPlaceholder: 'display order',
  selectAtLeastOnePlan: 'Please choose at least one option',
};
